import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertCircle } from 'lucide-react';
export function Identification() {
  const painPoints = ['Quieres generar ingresos desde casa', 'Has visto demasiada información y te sientes confundida', 'Te interesa Amazon pero no sabes cómo empezar', 'Tienes miedo de invertir y equivocarte'];
  return <section className="bg-brand-beige py-20 px-6" data-id="element-162">
      <div className="max-w-6xl mx-auto" data-id="element-163">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-164">
          {/* LEFT COLUMN — All text content */}
          <div className="flex-1 w-full" data-id="element-165">
            <FadeIn data-id="element-166">
              <h2 className="text-3xl md:text-4xl font-bold text-brand-green mb-10" data-id="element-167">
                Si estás aquí, probablemente:
              </h2>
            </FadeIn>

            <div className="space-y-4 mb-10" data-id="element-168">
              {painPoints.map((point, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-169">
                  <div className="flex items-center gap-4 bg-white p-6 rounded-xl shadow-sm border border-brand-green/5" data-id="element-170">
                    <div className="flex-shrink-0 w-10 h-10 bg-brand-beige rounded-full flex items-center justify-center" data-id="element-171">
                      <AlertCircle className="w-5 h-5 text-brand-gold" data-id="element-172" />
                    </div>
                    <p className="text-lg text-brand-text font-medium" data-id="element-173">
                      {point}
                    </p>
                  </div>
                </FadeIn>)}
            </div>

            <FadeIn delay={0.5} data-id="element-174">
              <div className="space-y-4 text-xl md:text-2xl font-serif text-brand-green text-center" data-id="element-175">
                <p className="flex items-center justify-center gap-2" data-id="element-176">
                  <span data-id="element-177">👉</span> Y no es tu culpa…
                </p>
                <p className="flex items-center justify-center gap-2" data-id="element-178">
                  <span data-id="element-179">👉</span> Nadie te ha explicado esto de forma clara y
                  práctica
                </p>
              </div>
            </FadeIn>
          </div>

          {/* RIGHT COLUMN — Image only */}
          <div className="flex-shrink-0 w-full lg:w-[40%]" data-id="element-180">
            <FadeIn delay={0.3} data-id="element-181">
              <img src="https://cdn.magicpatterns.com/uploads/iKJ3MUFSanJqHtjyLiZNxg/ChatGPT_Image_6_abr_2026,_21_05_48.png" alt="Mujer trabajando desde casa con laptop en ambiente cálido" className="w-full h-auto rounded-2xl shadow-lg object-contain" data-id="element-182" />
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}